module.exports = __webpack_public_path__ + "media/34.61353ca5.mp3";